import { mapState } from 'vuex';
import preview from "../preview/index.vue";

export default {
    name: 'cources_list',
    props: {
        scroll : Number
    },

    components : {
        preview
    },

    data : function(){

        return {
			loading : false,
			searchvalue : '',
			count : 0,
			sort : 'date_desc',
			sorting : {

				date_asc : {
					text : 'date_asc',
					field : 'ss.date',
					sort : 'asc'
				},
				date_desc : {
					text : 'date_desc',
					field : 'ss.date',
					sort : 'desc'
				}
			},

            payloadsSample : 'all',

            level : ''

		}

    },

    created : () => {

    },

    watch: {
		tscrolly : function(){

			if (this.$refs['list']){

				if (this.$refs['list'].height() - 1000 < this.tscrolly + this.dheight){
					this.$refs['list'].next()
				}
				
			}
			
		}
	},
    computed: mapState({
        dheight: state => state.dheight,
        tscrolly : function(state){
            return this.scroll || state.tscrolly
        },
        auth : state => state.auth,
        userinfo : state => state.userinfo?.userinfo,

        admin : function(){
            return this.core.user.checkFeatures(['admin'])
        },

     

        payloadsSamples : function(){
			var s = {
                all : {
					text : 'labels.all',
					payload : {
					}
				}
            } 

            if(this.auth){

                if(!this.admin){
                    s.myall = {
                        text : 'snippity.course.myall',
                        payload : {
                            'sui.status' : 'NOTNULL'
                        }
                    }

                    s.mycurrent = {
                        text : 'snippity.course.mycurrent',
                        payload : {
                            'sui.status' : 'join'
                        }
                    }
                }
                else{
                    s.notdeleted = {
                        text : 'snippity.course.notdeleted',
                        payload : {
                            'ss.deleted' : 0
                        }
                    }

                    s.deleted = {
                        text : 'snippity.course.deleted',
                        payload : {
                            'ss.deleted' : 1
                        }
                    }
                }

                
            }

            return s
            
            

		},

        payload : function(){

            var p = {
                sortFields : [{
                    field : this.sorting[this.sort].field,
                    order : this.sorting[this.sort].sort
                }],
                fieldsFilter : {
                }
            }

            if(this.searchvalue){
                p.fieldsFilter['si.searchvalue'] = {
                    match : true,
                    fields : ['si.topic', 'si.name', 'si.summary'],
                    value : this.searchvalue
                }
            }

            if(!this.admin){
                p.fieldsFilter.deleted = 0
            }

            if(this.level){
                p.fieldsFilter['si.path'] = {
                    value : _.last(this.level.split('.')),
                    instr : true
                }
            }

            if(this.auth){
                p.fieldsFilter['si.age'] = {
                    value : this.userinfo.ageCluster[1],
                    instr : true
                }
            }

            p.fieldsFilter = {
				...p.fieldsFilter,
				...this.payloadsSamples[this.payloadsSample].payload
			}

            console.log('p.fieldsFilter', p.fieldsFilter)
        
            return p
        },

        api : function(){

            return 'lessons.list'
            
        }
    }),

    methods : {

        payloadsSampleChanged : function(v){
			this.payloadsSample = v
		},

        reload : function(){
            if(this.$refs['list']) this.$refs['list'].reload()
        },

        search : function(v){
            this.searchvalue = v
        },

        setcount : function(v){
            console.log('setcount', v)
            this.count = v
        },

        sortchange : function(v){
            this.sort = v
        },

        opencatalog : function(){

            if(!this.userinfo) return

            console.log('this.userinfo', this.level)

            this.core.vueapi.catalog({
                locale : this.userinfo.locale,
                age : this.userinfo.ageCluster[1],
                initial : this.level
            }, {
                apply : (l) => {
                    this.level = l
                }
            })

        }
    },
}